<template>
  <div
    v-if="visibleTooltip"
    ref="tooltipEl"
    class="tooltip"
    :class="[{'active': activeTooltip}, sideClass]"
  >
    <!--    <div class="close-icon" @click="closeTooltip">-->
    <!--      <svg-->
    <!--        width="16"-->
    <!--        height="16"-->
    <!--        viewBox="0 0 24 24"-->
    <!--        fill="none"-->
    <!--        xmlns="http://www.w3.org/2000/svg"-->
    <!--      >-->
    <!--        <path-->
    <!--          d="M12.0007 0.333008C5.54898 0.333008 0.333984 5.54801 0.333984 11.9997C0.333984 18.4513 5.54898 23.6663 12.0007 23.6663C18.4523 23.6663 23.6673 18.4513 23.6673 11.9997C23.6673 5.54801 18.4523 0.333008 12.0007 0.333008ZM17.834 16.188L16.189 17.833L12.0007 13.6447L7.81232 17.833L6.16732 16.188L10.3557 11.9997L6.16732 7.81134L7.81232 6.16634L12.0007 10.3547L16.189 6.16634L17.834 7.81134L13.6457 11.9997L17.834 16.188Z"-->
    <!--          fill="#FFFFFF"-->
    <!--        />-->
    <!--      </svg>-->
    <!--    </div>-->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    targetRef: {
      type: [HTMLElement, Object],
      required: true,
    },
    side: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      visibleTooltip: false,
      activeTooltip: false,
      targetElement: null,
    };
  },
  computed: {
    sideClass() {
      return `${this.side}`;
    },
  },
  watch: {
    targetRef(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return;
      this.removeHoverListener();
      this.addHoverListener();
    },
  },
  mounted() {
    if (this.targetRef) {
      this.addHoverListener();
    }
  },
  beforeDestroy() {
    this.removeHoverListener();
  },
  methods: {
    showTooltip(retryCount = 0) {
      if (!this.targetElement) {
        this.targetElement = this.targetRef instanceof HTMLElement ? this.targetRef :
          (this.targetRef && this.targetRef.$el) ? this.targetRef.$el :
            (this.targetRef && typeof this.targetRef === 'object') ? this.targetRef : null;

        if (!this.targetElement && retryCount < 5) {
          setTimeout(() => {
            this.showTooltip(retryCount + 1);
          }, 100);
          return;
        }

        if (!this.targetElement) {
          console.error('Target element not available for tooltip');
          return;
        }
      }

      this.visibleTooltip = true;

      setTimeout(() => {
        try {
          const targetElementRect = this.targetElement.getBoundingClientRect();
          const tooltip = this.$refs.tooltipEl;
          if (!tooltip) return;

          const tooltipRect = tooltip.getBoundingClientRect();
          tooltip.style.left = `${targetElementRect.left - 24}px`;
          switch (this.sideClass) {
            case 'bottom':
              tooltip.style.top = `${targetElementRect.bottom + 6}px`;
              break;
            case 'top':
            default:
              tooltip.style.top = `${targetElementRect.top - tooltipRect.height - 6}px`;
          }

          this.activeTooltip = true;
        } catch (error) {
          console.error('Error showing tooltip:', error);
          this.hideTooltip();
        }
      }, 50);
    },
    hideTooltip() {
      this.activeTooltip = false;
      this.visibleTooltip = false;
    },
    closeTooltip() {
      this.hideTooltip();
    },
    addHoverListener() {
      this.targetElement = this.targetRef instanceof HTMLElement ? this.targetRef : this.targetRef.value;
      if (!this.targetElement) return;
      this.targetElement.addEventListener('mouseenter', this.showTooltip);
      this.targetElement.addEventListener('mouseleave', this.hideTooltip);
    },
    removeHoverListener() {
      if (!this.targetElement) return;
      this.targetElement.removeEventListener('mouseenter', this.showTooltip);
      this.targetElement.removeEventListener('mouseleave', this.hideTooltip);
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: fixed;
  visibility: hidden;
  background-color: var(--secondary-black-color);
  box-shadow: 0px 8px 16px 0px #0000001F;
  padding: 10px;
  z-index: 9999;
  max-width: 300px;
  border-radius: 4px;
}

.tooltip span {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--white-color);
  white-space: break-spaces;
}

.active {
  visibility: visible;
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 1;
}
</style>
